import initReleases from '~/releases/mount_index';

initReleases();
